export default {
  // Grey general note (restored per PM video) — the full one-per-order rule, shown on the
  // offer sheet and the promo/gift modal. Automatic discounts (smart pricing) still stack.
  general_note:
    'Promocodes en cadeaubonnen kunnen niet worden gecombineerd met andere kortingen. Een aanbieding en een puntsinwisseling kunnen samen worden gebruikt. Automatische kortingen zoals de afhaalkorting zijn nog steeds van toepassing.',
  // Full note — offer detail sheet + promo/gift entry (CTO shortened to one line, 2026-07-31).
  full_note: 'Promocodes en cadeaubonnen kunnen niet worden gecombineerd met andere kortingen.',
  // Green status pill on the offer sheet when the offer's requirement is met (prototype).
  unlocked: 'Ontgrendeld',
  // Short static exclusion note per surface (card footers, CTO-confirmed copy).
  footer: {
    offer: 'Kan niet worden gecombineerd met promocodes of cadeaubonnen.',
    promo: 'Kan niet worden gecombineerd met aanbiedingen, cadeaubonnen of punten.',
    gift: 'Kan niet worden gecombineerd met aanbiedingen, promocodes of punten.',
  },
  // State-aware conflict line — names the discount that will be displaced.
  // Full mutual exclusivity (PM video): offer, promo, gift and points all block each other.
  conflict: {
    offer_blocked_by_promo: 'Er is een promocode toegepast. Door deze aanbieding te gebruiken wordt die verwijderd.',
    offer_blocked_by_gift: 'Er is een cadeaubon toegepast. Door deze aanbieding te gebruiken wordt die verwijderd.',
    offer_blocked_by_points:
      'Er is een puntsinwisseling actief. Door deze aanbieding te gebruiken wordt die verwijderd.',
    promo_gift_displaces_offer: 'Het toepassen van een promocode of cadeaubon verwijdert je actieve aanbieding.',
    promo_gift_displaces_points: 'Het toepassen van een promocode of cadeaubon verwijdert je puntsinwisseling.',
    promo_gift_displaces_offer_and_points:
      'Het toepassen van een promocode of cadeaubon verwijdert je actieve aanbieding en puntsinwisseling.',
  },
  // Comparison-choice card (Inc 4, FOO-2567) — offer / promo detail modals when a conflicting
  // discount is already applied. Lets the customer pick, flagging the higher saving as best.
  comparison: {
    active_line: 'Deze {{kind}} is al actief: {{name}} ({{saving}}).',
    active_line_no_saving: 'Deze {{kind}} is al actief: {{name}}.',
    candidate_line: 'De {{kind}} bespaart {{saving}}.',
    only_one: 'Je kunt er maar één gebruiken.',
    best_choice: 'Beste keuze',
    keep: 'Behoud {{label}}',
    use_instead: 'Gebruik {{label}} in plaats daarvan',
    kinds: {
      offer: 'aanbieding',
      promo: 'promocode',
      gift: 'cadeaubon',
      points: 'puntsinwisseling',
    },
    // Concise nouns for the Keep/Use buttons ("Keep offer", "Use code instead").
    button_kinds: {
      offer: 'aanbieding',
      promo: 'code',
      gift: 'cadeaubon',
      points: 'punten',
    },
    // Single-action variant (offer modal, promo/gift already active): one sentence + only the
    // "Use offer instead" button — closing the window keeps the code (CTO 2026-08-03).
    single_message:
      '{{active}} is al actief. Er kan maar één korting per bestelling worden gebruikt — gebruik deze aanbieding in plaats daarvan, of sluit dit venster om je code te bewaren.',
    active_named: {
      promo: 'Promocode {{name}} ({{saving}})',
      gift: 'Cadeaubon ({{saving}})',
    },
    active_named_no_saving: {
      promo: 'Promocode {{name}}',
      gift: 'Cadeaubon',
    },
    // Multiple active offers (item 6) — promo modal comparison, replaces the active/candidate lines.
    active_offers_two:
      'Je hebt {{count}} actieve aanbiedingen: {{first}} ({{firstValue}}) en {{second}} ({{secondValue}}) — {{total}} samen. Promocode {{code}} bespaart {{codeValue}} op deze bestelling. Er kan er maar één worden gebruikt.',
    active_offers_more:
      'Je hebt {{count}} actieve aanbiedingen: {{first}} ({{firstValue}}), {{second}} ({{secondValue}}) en {{more}} meer — {{total}} samen. Promocode {{code}} bespaart {{codeValue}} op deze bestelling. Er kan er maar één worden gebruikt.',
  },
  // Discount-card status tag (deals carousel — offer + promo cards), Inc 3.
  card: {
    available: 'Nu beschikbaar',
    applied: 'Toegepast · {{savings}} korting',
    applied_plain: 'Toegepast',
    replaces: 'Kan niet worden gecombineerd met {{label}} · Vervangt {{name}}',
    replaces_no_name: 'Kan niet worden gecombineerd met {{label}}',
    // Prototype card treatment (blocked-by-conflict): a warning line naming the active discount,
    // the one-per-order note, and a "Replaces …" line.
    cannot_combine: 'Kan niet worden gecombineerd met {{name}}',
    replaces_name: 'Vervangt {{name}}',
    // Multiple active offers (n>1) — show a count + total instead of a single offer name (item 6).
    cannot_combine_offers: 'Kan niet worden gecombineerd met je {{count}} actieve aanbiedingen',
    replaces_offers: 'Vervangt {{count}} actieve aanbiedingen ({{total}})',
    // Generic type label for the active discount that would be displaced.
    kind: {
      offer: 'een aanbieding',
      promo: 'een promocode',
      gift: 'een cadeaubon',
      points: 'je puntsinwisseling',
    },
  },
  // DisplacementNotice (cart drawer + checkout) — bidirectional & entity-named (PM video).
  // One discount displaced another; the message names both, and Undo restores the displaced one.
  // e.g. "Promo code CHEVERE applied. This removed the 2-für-1 offer. [Undo]".
  displacement: {
    message: '{{applied}} toegepast. Dit heeft {{removed}} verwijderd.',
    // Multiple offers removed at once (item 6) — names the top two + the total, in cart + checkout.
    offer_removed_multi: {
      promo:
        'Promocode {{code}} ({{codeValue}}) toegepast. Dit heeft {{count}} aanbiedingen verwijderd: {{first}} en {{second}} ({{total}}).',
      gift: 'Cadeaubon toegepast. Dit heeft {{count}} aanbiedingen verwijderd: {{first}} en {{second}} ({{total}}).',
    },
    undo: 'Ongedaan maken',
    // The discount that is currently applied (the "winner").
    applied: {
      offer: 'Aanbieding {{name}}',
      promo: 'Promocode {{code}}',
      gift: 'Cadeaubon',
      points: '{{count}} punten',
    },
    // The discount that was displaced (the "loser"), restored by Undo.
    removed: {
      offer: 'de aanbieding {{name}}',
      promo: 'de promocode {{code}}',
      gift: 'de cadeaubon',
      points: 'je puntsinwisseling',
    },
    // UX feedback item 3 — points redemption displacing a promo/gift. Layer A: a zero-friction hint
    // under the "Use your points" header, shown only while a code/gift is active (before they tap).
    points_hint: {
      promo: 'Het gebruik van punten verwijdert promocode {{name}} (–{{saving}})',
      gift: 'Het gebruik van punten verwijdert de cadeaubon (–{{saving}})',
      promo_no_saving: 'Het gebruik van punten verwijdert promocode {{name}}',
      gift_no_saving: 'Het gebruik van punten verwijdert de cadeaubon',
    },
    // Layer B: the post-action displacement notice, extended to the points→code direction.
    points_displaced: {
      promo: '{{points}} punten toegepast (–{{pointsSaving}}). Promocode {{name}} (–{{couponSaving}}) is verwijderd.',
      gift: '{{points}} punten toegepast (–{{pointsSaving}}). Cadeaubon (–{{couponSaving}}) is verwijderd.',
      promo_no_saving: '{{points}} punten toegepast (–{{pointsSaving}}). Promocode {{name}} is verwijderd.',
      gift_no_saving: '{{points}} punten toegepast (–{{pointsSaving}}). Cadeaubon is verwijderd.',
    },
  },
};
